// RoleBasedLayout.tsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { getToken, getUserIdFromToken } from '../auth/service/authService';
import { User } from '../auth/model/User';

import {AdminLayout} from "./admin/layout/AdminLayout";
import {CustomerLayout} from "./customer/layout/CustomerLayout";
import {Box} from "@mantine/core";
import {BackendUrl} from "../util/config";

/**
 * A layout that decides whether to render the Admin or Customer layout
 * based on the current user's role.
 */
export const RoleBasedLayout: React.FC = () => {
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const token = getToken();
        const userId = getUserIdFromToken();

        if (!token || !userId) {
            // No valid token => force login
            navigate('/login');
            return;
        }

        // Fetch user to get role or read from a global user context
        axios
            .get<User>(BackendUrl + `/users/${userId}`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((resp) => {
                setUser(resp.data);
            })
            .catch((err) => {
                console.error(err);
                navigate('/login');
            })
            .finally(() => setLoading(false));
    }, [navigate, location]);

    if (loading) {
        // Show a loading spinner or skeleton
        return <Box>Loading...</Box>;
    }

    // If user was fetched, choose the layout
    if (user?.role === 'ADMIN') {
        return <AdminLayout />;
    } else if (user?.role === 'CUSTOMER') {
        return <CustomerLayout />;
    } else {
        // Unknown role => maybe force logout or show an error
        return <Box>Unauthorized role!</Box>;
    }
};
